export const mainRatesArray = [
  { duration: '1 Hour', price: '£200' },
  { duration: '2 Hours', price: '£400' },
  { duration: '3 Hours', price: '£600' },
  { duration: 'Overnight', price: '£1600' },
];

export const dominationRatesArray = [
  { duration: '1 Hour', price: '£200' },
  { duration: '2 Hours', price: '£400' },
  { duration: '3 Hours', price: '£600' },
  { duration: 'Overnight', price: '£1600' },
];

export const sploshingRatesArray = [
  { duration: '2 Hours', price: '£400' },
  { duration: '3 Hours', price: '£600' },
];

export const wrestlingRatesArray = [
  { duration: '½ Hour', price: '£100' },
  { duration: '1 Hour', price: '£200' },
  { duration: '2 Hours', price: '£400' },
];
